var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kxxm8c622a",
    d: "M21.98.129C9.84.129 0 10.249 0 22.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574C43.96 10.248 34.12.129 21.98.129z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-797 -709) translate(95 157) translate(406 552) translate(88) translate(208)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g71b7r650b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kxxm8c622a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0077B5",
    d: "M21.98 1.129C9.84 1.129 0 11.249 0 23.731c0 12.483 9.84 22.602 21.98 22.602 1.82 0 3.587-.228 5.279-.656 4.42 5.635 14.494 6.238 14.494 6.238s-6.929-4.932-5.951-10.61c4.976-4.143 8.158-10.476 8.158-17.574 0-12.483-9.84-22.602-21.98-22.602z",
    mask: "url(#g71b7r650b)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.994 24v-.001H24v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07V7.976H8.489v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243V24h4.965zM.396 7.977L5.372 7.977 5.372 24 .396 24zM2.882 0C1.291 0 0 1.291 0 2.882c0 1.591 1.291 2.909 2.882 2.909 1.591 0 2.882-1.318 2.882-2.909C5.763 1.291 4.472 0 2.882 0z",
    transform: "translate(-797 -709) translate(95 157) translate(406 552) translate(88) translate(208) translate(11 9)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.956cb1ff78fba59ddcfa3c6de153287a.svg";
export { ForwardRef as ReactComponent };